import React from "react";
import { useApply } from "@/context/ApplyContext";

export const Header = () => {
  const { openApply } = useApply();
  return (
    <header className="sticky top-0 z-50 backdrop-blur-md bg-white/90 border-b border-zinc-200">
      <div className="max-w-[1100px] mx-auto px-6 h-16 flex items-center justify-between">
        <span data-testid="logo" className="font-black tracking-tight text-lg md:text-xl text-zinc-900">
          Full Time Guitar
        </span>
        <button
          data-testid="header-apply-btn"
          onClick={openApply}
          className="bg-[#D90429] hover:bg-[#B90323] text-white px-5 py-2.5 rounded-lg font-bold text-sm uppercase tracking-wide transition-colors focus:outline-none focus:ring-4 focus:ring-[#D90429]/40"
        >
          Apply
        </button>
      </div>
    </header>
  );
};
